// TORUNA ERP — Design System Tokens
// Aesthetic: Industrial Refined — deep crimson, dark slate, crisp surfaces

export const colors = {
  // Brand
  primary: '#c62828',
  primaryLight: '#ef5350',
  primaryDark: '#8e0000',
  primaryGhost: 'rgba(198, 40, 40, 0.08)',

  // Neutral
  secondary: '#1a2332',
  secondaryLight: '#243044',
  surface: '#ffffff',
  background: '#f0f2f5',
  backgroundAlt: '#f8fafc',

  // Borders
  border: '#e2e8f0',
  borderLight: '#f1f5f9',
  divider: '#eef2f6',

  // Text
  textPrimary: '#1a2332',
  textSecondary: '#64748b',
  textTertiary: '#94a3b8',
  textInverse: '#ffffff',
  textOnPrimary: '#ffffff',

  // Semantic
  success: '#16a34a',
  successLight: '#dcfce7',
  warning: '#d97706',
  warningLight: '#fef3c7',
  danger: '#dc2626',
  dangerLight: '#fee2e2',
  info: '#0284c7',
  infoLight: '#e0f2fe',
};

export const spacing = {
  xs: '4px',
  sm: '8px',
  md: '12px',
  base: '16px',
  lg: '20px',
  xl: '24px',
  '2xl': '32px',
  '3xl': '40px',
  '4xl': '48px',
};

export const radius = {
  sm: '6px',
  md: '8px',
  lg: '12px',
  xl: '16px',
  full: '9999px',
};

export const shadows = {
  sm: '0 1px 3px rgba(0,0,0,0.08)',
  md: '0 4px 12px rgba(0,0,0,0.1)',
  lg: '0 8px 24px rgba(0,0,0,0.12)',
  xl: '0 12px 40px rgba(0,0,0,0.16)',
  inner: 'inset 0 2px 4px rgba(0,0,0,0.04)',
  glow: '0 0 0 3px rgba(198, 40, 40, 0.15)',
};

export const typography = {
  fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
  heading: {
    xl: { fontSize: '28px', fontWeight: '700', lineHeight: '1.2', letterSpacing: '-0.02em' },
    lg: { fontSize: '22px', fontWeight: '700', lineHeight: '1.3', letterSpacing: '-0.01em' },
    md: { fontSize: '18px', fontWeight: '600', lineHeight: '1.4' },
    sm: { fontSize: '15px', fontWeight: '600', lineHeight: '1.4' },
  },
  body: {
    lg: { fontSize: '16px', fontWeight: '400', lineHeight: '1.6' },
    md: { fontSize: '14px', fontWeight: '400', lineHeight: '1.5' },
    sm: { fontSize: '13px', fontWeight: '400', lineHeight: '1.5' },
    xs: { fontSize: '11px', fontWeight: '500', lineHeight: '1.4', letterSpacing: '0.02em' },
  },
  label: { fontSize: '13px', fontWeight: '500', color: colors.textSecondary },
  overline: { fontSize: '11px', fontWeight: '600', letterSpacing: '0.08em', textTransform: 'uppercase', color: colors.textTertiary },
};

// Backward compat — old `styles` export used across all pages
export const styles = {
  // Ana renkler (eski API korunuyor)
  primary: colors.primary,
  primaryDark: colors.primaryDark,
  secondary: colors.secondary,
  success: colors.success,
  warning: colors.warning,
  danger: colors.danger,
  info: colors.info,

  // Durum badge renkleri
  statusColors: {
    'BEKLENIYOR': { bg: colors.warningLight, color: '#92400e' },
    'ONAYLANDI': { bg: colors.infoLight, color: '#075985' },
    'SİPARİŞ VERİLDİ': { bg: colors.successLight, color: '#166534' },
    'TESLİM ALINDI': { bg: '#dbeafe', color: '#1e40af' },
    'HAZIRLANIYOR': { bg: colors.warningLight, color: '#92400e' },
    'YOLDA': { bg: colors.infoLight, color: '#075985' },
    'ÖDENMEDI': { bg: colors.dangerLight, color: '#991b1b' },
    'ODENECEK': { bg: colors.dangerLight, color: '#991b1b' },
    'ÖDENDİ': { bg: colors.successLight, color: '#166534' },
    'BEKLEMEDE': { bg: colors.warningLight, color: '#92400e' },
    'REDDEDILDI': { bg: colors.dangerLight, color: '#991b1b' },
    'OK': { bg: colors.successLight, color: '#166534' },
    'EKSIK': { bg: colors.warningLight, color: '#92400e' },
    'FAZLA': { bg: colors.infoLight, color: '#075985' },
    'HASARLI': { bg: colors.dangerLight, color: '#991b1b' },
    'BEKLIYOR': { bg: colors.warningLight, color: '#92400e' },
    'ONAY_BEKLIYOR': { bg: '#f3e8ff', color: '#7c3aed' },
    'SIPARIS_VERILDI': { bg: colors.successLight, color: '#166534' },
    'SIPARIS_HAZIRLANIYOR': { bg: colors.warningLight, color: '#92400e' },
    'KISMI_TESLIM': { bg: '#dbeafe', color: '#1e40af' },
    'TESLIM_ALINDI': { bg: colors.successLight, color: '#166534' },
    'IPTAL': { bg: colors.dangerLight, color: '#991b1b' },
    'YUKLENDI': { bg: colors.warningLight, color: '#92400e' },
    'ISLENDI': { bg: colors.successLight, color: '#166534' },
    'HATA': { bg: colors.dangerLight, color: '#991b1b' },
    'TASLAK': { bg: '#f1f5f9', color: '#475569' },
    'TAMAMLANDI': { bg: colors.successLight, color: '#166534' },
  }
};
